/**
 * Node Service - API Implementation
 * Uses real API instead of localStorage
 */

import { apiClient } from './apiClient'
import { AnyNode, NodeType } from '@/types/nodes'

export const nodeServiceApi = {
  /**
   * Get all nodes
   */
  async getAll(): Promise<AnyNode[]> {
    try {
      return await apiClient.get<AnyNode[]>('/api/nodes')
    } catch (error) {
      console.error('Error fetching nodes:', error)
      return []
    }
  },

  /**
   * Get node by ID
   */
  async getById(id: string): Promise<AnyNode | null> {
    try {
      return await apiClient.get<AnyNode>(`/api/nodes/${id}`)
    } catch (error) {
      console.error(`Error fetching node ${id}:`, error)
      return null
    }
  },

  /**
   * Create new node
   */
  async create(nodeData: Partial<AnyNode>): Promise<AnyNode> {
    try {
      return await apiClient.post<AnyNode>('/api/nodes', nodeData)
    } catch (error) {
      console.error('Error creating node:', error)
      throw error
    }
  },

  /**
   * Update node
   */
  async update(id: string, nodeData: Partial<AnyNode>): Promise<AnyNode> {
    try {
      return await apiClient.patch<AnyNode>(`/api/nodes/${id}`, nodeData)
    } catch (error) {
      console.error(`Error updating node ${id}:`, error)
      throw error
    }
  },

  /**
   * Delete node
   */
  async delete(id: string): Promise<void> {
    try {
      await apiClient.delete(`/api/nodes/${id}`)
    } catch (error) {
      console.error(`Error deleting node ${id}:`, error)
      throw error
    }
  },

  /**
   * Get nodes by type
   */
  async getByType(type: NodeType): Promise<AnyNode[]> {
    try {
      const nodes = await this.getAll()
      return nodes.filter((node) => node.tipo === type)
    } catch (error) {
      console.error(`Error fetching nodes by type ${type}:`, error)
      return []
    }
  },

  /**
   * Get nodes by folder
   */
  async getByFolder(folderId: string): Promise<AnyNode[]> {
    try {
      const nodes = await this.getAll()
      return nodes.filter((node: any) => node.folderId === folderId)
    } catch (error) {
      console.error(`Error fetching nodes by folder ${folderId}:`, error)
      return []
    }
  },
}
